import {
    GET_NOTIFICATION_MESSAGE,
    GET_NOTIFICATION_MESSAGE_ERROR,
    SHOW_ACCESS_DENIED_NOTIFICATION, SHOW_ERROR_TOKEN_NOTIFICATION,
    SHOW_FORBIDDEN_NOTIFICATION,
    SHOW_NOT_FOUND_NOTIFICATION
} from "../types/typesNotification";
import {logToast} from "../../utils/appEventLogs";

export function showAccessDeniedNotifications(state: any) {
    if (state) {
        logToast('access_denied');
    }
    return {
        type: SHOW_ACCESS_DENIED_NOTIFICATION,
        payload: state
    }
}

export function showNotFoundNotifications(state: any) {
    return {
        type: SHOW_NOT_FOUND_NOTIFICATION,
        payload: state
    }
}

export function getNotificationsMessage(state: any) {
    return {
        type: GET_NOTIFICATION_MESSAGE,
        payload: state
    }
}

export function getNotificationMessageError(state: any) {
    return {
        type: GET_NOTIFICATION_MESSAGE_ERROR,
        payload: state
    }
}

export function showErrorTokenNotifications(state: any) {
    if (state) {
        logToast('token_error');
    }
    return {
        type: SHOW_ERROR_TOKEN_NOTIFICATION,
        payload: state
    }
}

export function showForbiddenNotification(state: {message: string | null} | null) {
    if (state) {
        logToast('forbidden', {message: state.message || ''});
    }
    return {
        type: SHOW_FORBIDDEN_NOTIFICATION,
        payload: state
    }
}
